module.exports = __webpack_public_path__ + "static/img/no-data.15f4101e.png";